import { Field } from "react-final-form";
import { OnChange } from "react-final-form-listeners";
import { Col } from "reactstrap";
import { DetailedErrorAlert } from "../../components/DetailedErrorAlert";
import { FormRow } from "../../components/forms/FormRow";
import { CollectionTypeSelector } from "../../components/inputs/CollectionTypeSelector";
import { SerializedCptSelector } from "../../components/inputs/final_form/CptSelector";
import { DateInput } from "../../components/inputs/final_form/DateInput";
import { SerializedIcd10Selector } from "../../components/inputs/final_form/Icd10Selector";
import { SerializedLabSelector } from "../../components/inputs/final_form/LabSelector";
import { Switch } from "../../components/inputs/final_form/Switch";
import { TestSelector } from "../../components/inputs/final_form/TestSelector";
import { useSelectedTestUpdateFunction } from "../../new_case/TestAndRequestInfoHelperMethods";
import { featureEnabled } from "../../util/feature";
import { composeValidators, required, requiredNotNull } from "../../util/validators";

const multiplierFlagEnabled = featureEnabled("use_procedure_code_multiplier_column");

export const OrderInfo = ({ form, values }) => {
  const {
    updateTestInfoFromSelectedTestIds,
    error: selectedMappingsError,
    loading: loadingSelectedMappings,
  } = useSelectedTestUpdateFunction(form, multiplierFlagEnabled);

  return (
    <>
      <div className="mb-2">
        <h5 className="fw-bold text-dark">Test Info</h5>
      </div>
      <FormRow>
        <Col xs="12">
          <Field
            required
            name="labId"
            validate={composeValidators(requiredNotNull)}
            render={SerializedLabSelector}
            placeholder="Choose a Lab..."
            label="Lab"
          />
        </Col>
      </FormRow>

      <FormRow>
        <Col>
          <Field id="allTests" component={Switch} label="Show all tests" name="allTests" type="checkbox" />
        </Col>
      </FormRow>

      <FormRow>
        <Col>
          <Field
            name="testInfo.verifiedTestIds"
            validate={composeValidators(required)}
            component={TestSelector}
            allTests={values.allTests}
            labIds={[values.labId]}
            label={"Test Name"}
            data-testid="verifiedTestIds"
            required
            isMulti
          />

          <DetailedErrorAlert error={selectedMappingsError} />

          <OnChange name="testInfo.verifiedTestIds">{updateTestInfoFromSelectedTestIds}</OnChange>
        </Col>
      </FormRow>

      <FormRow>
        <Col>
          <Field
            required
            name="testInfo.cptCodes"
            label="CPT Codes"
            disabled={loadingSelectedMappings}
            component={SerializedCptSelector}
            validate={composeValidators(required)}
          />
        </Col>
        <Col>
          <Field
            required
            name="testInfo.icd10Codes"
            label="ICD 10 Codes"
            component={SerializedIcd10Selector}
            validate={composeValidators(required)}
          />
        </Col>
      </FormRow>

      <div className="my-2">
        <h5 className="fw-bold text-dark">Collection Info</h5>
      </div>

      <FormRow>
        <Col>
          <Field
            required
            name="testInfo.collectionType"
            label="Collection Type"
            component={(props) => <CollectionTypeSelector {...props} />}
            validate={composeValidators(required)}
          />
        </Col>
        <Col>
          <Field name="testInfo.collectionDate" label="Collection Date" render={DateInput} />
        </Col>
      </FormRow>
    </>
  );
};
